// import React from "react";
// import Slider from "react-slick";

// const Testimonials = () => {
//   const testimonials = [
//   {
//     name: "Mr. Santosh Prajapat",
//     location: "Mumbai, India",
//     message:
//       "Booking a ride with Omshree Cabs was seamless! The cab arrived on time, the driver was courteous, and the ride was comfortable. Highly recommend for city travel.",
//     rating: 5,
//   },
//   {
//     name: "Ms. Priya Sharma",
//     location: "Delhi, India",
//     message:
//       "I regularly use Omshree Cabs for airport pickups. Their service is reliable, drivers are professional, and the booking process is very easy. Makes travel stress-free!",
//     rating: 5,
//   },
//   {
//     name: "Mr. Ankit Mehra",
//     location: "Bangalore, India",
//     message:
//       "Omshree Cabs made our family trip so much easier! The car was spacious, clean, and the driver ensured a smooth and safe journey throughout our travel.",
//     rating: 5,
//   },
//   {
//     name: "Ms. Sneha Reddy",
//     location: "Hyderabad, India",
//     message:
//       "As someone who travels frequently for business, I trust Omshree Cabs. They have a wide range of cabs, punctual drivers, and excellent customer service every time.",
//     rating: 5,
//   },
//   {
//     name: "Mr. Vijay Singh",
//     location: "Chennai, India",
//     message:
//       "Our weekend getaway was made so easy with Omshree Cabs. The SUV we booked was spacious, comfortable, and the ride was smooth. Truly a reliable cab service.",
//     rating: 5,
//   },
// ];

//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     speed: 1000,
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 4000,
//     responsive: [
//       { breakpoint: 1024, settings: { slidesToShow: 2 } },
//       { breakpoint: 768, settings: { slidesToShow: 1 } },
//       { breakpoint: 480, settings: { slidesToShow: 1 } },
//     ],
//   };

//   return (
//     <section className="section about-testimonial testimonials-section">
//       <div className="container">
//         {/* Heading */}
//         <div className="section-heading" data-aos="fade-down">
//           <h2 className="title text-white">What People say about us?</h2>
//           <p className="description text-white">
//             Discover what our customers have think about us
//           </p>
//         </div>

//         {/* Slider */}
//         <Slider {...sliderSettings} className="about-testimonials testimonial-group mb-0">
//           {testimonials.map((testimonial, index) => (
//             <div className="testimonial-item d-flex" key={index}>
//               <div className="card flex-fill">
//                 <div className="card-body">
//                   <div className="quotes-head"></div>
//                   <div className="review-box">
                  
//                     <div className="review-details">
//                       <h6>{testimonial.name}</h6>
//                       <p>{testimonial.location}</p>
//                     </div>
//                   </div>
//                   <p>{testimonial.message}</p>
//                   <div className="list-rating">
//                     <div className="list-rating-star">
//                       {Array.from({ length: 5 }).map((_, i) => (
//                         <i
//                           key={i}
//                           className={`fas fa-star ${i < testimonial.rating ? "filled" : ""}`}
//                         ></i>
//                       ))}
//                     </div>
//                     <p>
//                       <span>({testimonial.rating}.0)</span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;


import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const Testimonials = () => {

const testimonials = [
{
name: "Mr. Santosh Prajapat",
location: "Mumbai, India",
message:
"Booking a ride with Omshree Cabs was seamless! The cab arrived on time, the driver was courteous, and the ride was comfortable. Highly recommend for city travel.",
rating: 5,
},
{
name: "Ms. Priya Sharma",
location: "Delhi, India",
message:
"I regularly use Omshree Cabs for airport pickups. Their service is reliable, drivers are professional, and the booking process is very easy. Makes travel stress-free!",
rating: 5,
},
{
name: "Mr. Ankit Mehra",
location: "Bangalore, India",
message:
"Omshree Cabs made our family trip so much easier! The car was spacious, clean, and the driver ensured a smooth and safe journey throughout our travel.",
rating: 5,
},
{
name: "Ms. Sneha Reddy",
location: "Hyderabad, India",
message:
"As someone who travels frequently for business, I trust Omshree Cabs. They have a wide range of cabs, punctual drivers, and excellent customer service every time.",
rating: 5,
},
{
name: "Mr. Yuvraj Patel",
location: "Chennai, India",
message:
"Our weekend getaway was made so easy with Omshree Cabs. The SUV we booked was spacious, comfortable, and the ride was smooth. Truly a reliable cab service.",
rating: 5,
},
];

return (
<section className="section about-testimonial testimonials-section">
<div className="container">

<div className="section-heading" data-aos="fade-down">
<h2 className="title text-white">What People say about us?</h2>
<p className="description text-white">
Discover what our customers have think about us
</p>
</div>

<Swiper
modules={[Autoplay, Pagination]}
spaceBetween={20}
slidesPerView={1}
loop={true}
autoplay={{ delay: 4000 }}
pagination={{ clickable: true }}
breakpoints={{
768: {
slidesPerView: 1
},
1024: {
slidesPerView: 2
}
}}
>

{testimonials.map((testimonial, index) => (

<SwiperSlide key={index}>

<div className="testimonial-item d-flex">
<div className="card flex-fill">

<div className="card-body">

<div className="review-box">
<div className="review-details">
<h6>{testimonial.name}</h6>
<p>{testimonial.location}</p>
</div>
</div>

<p>{testimonial.message}</p>

<div className="list-rating">
<div className="list-rating-star">

{Array.from({ length: 5 }).map((_, i) => (
<i
key={i}
className={`fas fa-star ${i < testimonial.rating ? "filled" : ""}`}
></i>
))}

</div>

<span>({testimonial.rating}.0)</span>

</div>

</div>
</div>
</div>

</SwiperSlide>

))}

</Swiper>

</div>
</section>
);
};

export default Testimonials;